import React, { useMemo, useState } from "react";
import { IconButton, Stack, Typography } from "@mui/material";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { WorkspaceFolderOpenIcon, WorkspaceFolderCloseIcon } from "assets/material-custom-icons";
import { IFolder } from "store/types";

interface IProps {
  folder: IFolder;
  subIndex: number;
  selectedFolder: IFolder | null;
  setSelectedFolder: (folder: IFolder | null) => void;
}

export const Folder: React.FC<IProps> = ({ folder, subIndex, selectedFolder, setSelectedFolder }) => {
  const [arrow, setArrow] = useState<boolean>(false);
  const onArrowClick = () => setArrow(!arrow);

  const folderIcons = {
    opened: {
      arrow: KeyboardArrowDownIcon,
      folder: WorkspaceFolderOpenIcon
    },
    closed: {
      arrow: KeyboardArrowRightIcon,
      folder: WorkspaceFolderCloseIcon
    }
  };

  const renderIcons = useMemo(() => {
    const { arrow: ArrowIcon, folder: FolderIcon } = arrow ? folderIcons.opened : folderIcons.closed;

    return (
      <Stack direction="row" alignItems="center">
        {folder.children?.length && (
          <IconButton
            onClick={(e) => {
              e.stopPropagation();
              onArrowClick();
            }}
          >
            <ArrowIcon sx={{ cursor: "pointer" }} />
          </IconButton>
        )}
        <FolderIcon sx={{ fill: "#0A3142" }} />
      </Stack>
    );
  }, [arrow, folder]);

  return (
    <>
      <Stack
        data-folder
        direction="row"
        alignItems="center"
        sx={{
          backgroundColor: selectedFolder?.id === folder.id ? "#DBE8F5" : "transparent",
          "&:hover": { backgroundColor: selectedFolder?.id === folder.id ? "#DBE8F5" : "#f5f9fa" }
        }}
      >
        <Stack
          direction="row"
          alignItems="center"
          sx={{
            paddingLeft: subIndex == 1 ? "10px" : `${(subIndex - 1) * 40}px`,
            borderBottom: "1px solid  #DAE0E2",
            maxWidth: "450px",
            width: "100%",
            height: "39px",
            cursor: "pointer"
          }}
          gap="10px"
          onClick={() => setSelectedFolder(folder)}
        >
          {renderIcons}
          <Typography
            sx={{
              fontSize: "16px",
              color: "#0a3142",
              whiteSpace: "nowrap",
              textOverflow: "ellipsis",
              overflow: "hidden"
            }}
          >
            {folder.title}
          </Typography>
        </Stack>
      </Stack>
      {arrow &&
        folder.children?.map((subFolder) => (
          <Folder
            key={subFolder.id}
            folder={subFolder}
            subIndex={subIndex + 1}
            selectedFolder={selectedFolder}
            setSelectedFolder={setSelectedFolder}
          />
        ))}
    </>
  );
};
